import React from 'react'

const Pill = (props) => {
  const {children } = props
  return(
    <div className="pill fs--xs co--light ls--m">{children}</div>
  )
}

export default Pill